import * as angular from 'angular';
import * as moment from 'moment';

import {
    IAuthentication,
    ICurrentApplicationService,
    ILoggerService,
    ISingleSignOnService,
    IStoreService,
    IWorkspaceService
} from '../../../services';
import { wideService } from '../../../common';
import { ComponentDefinition, IApplicationConfiguration } from '../../../models';
import { StoreElement } from '../../../stateManagement';

export class SessionExpirationController implements angular.IComponentController, angular.IOnDestroy {
    application: IApplicationConfiguration; // Seems unused
    isDisplayed: boolean;
    isInDomain: boolean;
    minutes: number;
    userPassword: string;

    private _authentication: IAuthentication;
    private _date: Date;
    private _timer: angular.IPromise<any>;
    private _unsubscribe: () => void;

    static $inject = [
        '$q',
        '$state',
        '$timeout',
        'loggerService',
        'workspaceService',
        'singleSignOnService',
        'currentApplicationService',
        'storeService'
    ];
    constructor(
        private _$q: angular.IQService,
        private _$state: angular.ui.IStateService,
        private _$timeout: angular.ITimeoutService,
        private _loggerService: ILoggerService,
        private _workspaceService: IWorkspaceService,
        private _singleSignOnService: ISingleSignOnService,
        private _currentApplicationService: ICurrentApplicationService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.application = this._currentApplicationService.getApplicationConfiguration();
        this.isDisplayed = false;
        this._unsubscribe = this._storeService.register(store => {
            this.isInDomain = store.apiInformation.value?.isInDomain;
            const { authentication } = store;
            if (authentication.value) {
                const authData = authentication.value;
                this.isDisplayed = this.isDisplayed && authData.isAuth;
                if (authData.isAuth && authData.userName !== wideService) {
                    this._date = authData.expirationDate;
                    if (this._date) {
                        this.refresh();
                    } else {
                        this.isDisplayed = false;
                    }
                }
                this._authentication = authData;
            }
        }, [StoreElement.ApiInformation, StoreElement.Authentication]);
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    keyPress(e) {
        if (e && e.keyCode === 13) {
            this.refreshToken();
        }
    }

    refreshToken(useSSO: boolean = false): angular.IPromise<boolean> {
        if (this._authentication.expirationDate > new Date()){     
            let auth = {
                userName: this._authentication?.userName,
                password: this.userPassword
            };
    
            const workspace = this._workspaceService.getWorkspace();
    
            const promise = useSSO
                ? this._singleSignOnService.login()
                : this.tokenPromise(auth);
    
            const authenticationService = this._storeService.dispatchers().authentication;
            // first call to check password and prevent error
            return promise
                .then(() => workspace ? authenticationService.connectByWorkspace(auth.userName, workspace) : this._$q.when())
                .then(() => {
                    this._loggerService.logSuccess('Session is renewed');
                    $('#sessionExpirationModal').modal('hide');
                    this.init();
                    return true;
                }).catch((e) => {
                    this._loggerService.logError('Error on login, please check your password');
                    return false;
                }).finally(() => {
                    this.userPassword = null;
                    auth = null;
                });
        } else {
            const authenticationService = this._storeService.dispatchers().authentication;
            $('#sessionExpirationModal').modal('hide');
            authenticationService.logout();
            this._$state.go('login');
        }       
    }

    private tokenPromise(auth: { userName: string, password: string }): angular.IPromise<any> {
        const authenticationService = this._storeService.dispatchers().authentication;
        return authenticationService.login(auth, false)
            .then(() => {
                // it works, then logout and login again
                authenticationService.logout();
                return authenticationService.login(auth, false);
            });
    }

    private init() {
        if (!isNaN(this._date.valueOf())) {
            this.refresh();
        }
    }

    private refresh() {

        if (this._timer) {
            this._$timeout.cancel(this._timer);
            this._timer = null;
        }

        // 30 minutes before expiration
        const trigger = moment(this._date).add(-30, 'm');

        if (trigger.isBefore()) {
            this.activate();
        } else {
            const milli = trigger.diff(moment());
            this._timer = this._$timeout(self => self.activate(), milli, true, this);
        }
    }

    private activate() {
        this.isDisplayed = true;
    }
}

export const wtSessionExpiration: ComponentDefinition = {
    componentId: 'wtSessionExpiration',
    controller: SessionExpirationController,
    template: require('./sessionExpiration.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};